import { useFetchCount, FetchKey } from '@app/src/api/fetchHooks'
import endpoints from '@app/src/api/endpoints'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

export function useHasInquiriesWithProduct(): boolean {
  const { count } = useFetchCount({
    key: [FetchKey.InquiryCount, 'inquiriesWithProduct'],
    endpoint: endpoints.inquiryCount,
    payload: [
      {
        name: 'targetProductId',
        filters: [
          {
            operator: Operators.IsNotNull,
          },
        ],
      },
    ],
    options: { staleTime: ONE_MINUTE_MS },
  })
  return (count ?? 0) > 0
}
